function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import { injectIntl } from 'react-intl';
import en from './locales/SimpleDropZone.en.json';
import compose from '../../utils/compose';
import getOr from '../../utils/getOr';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import set from '../../utils/set';
import uuid from 'uuid/v4';
var getNested = getOr([]);

/**
 * i18n strings come from default messages as shown at
 * https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/screen-reader.md
 */
var SimpleDropZone = /*#__PURE__*/function (_React$Component) {
  _inherits(SimpleDropZone, _React$Component);
  function SimpleDropZone(props) {
    var _this;
    _classCallCheck(this, SimpleDropZone);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleDropZone).call(this, props));
    _this.messenger = function (id, values) {
      return _this.props.intl.formatMessage({
        id: id
      }, values);
    };
    _this.onDragBeforeStart = function (start, provided) {
      if (_this.props.onDragBeforeStart) {
        _this.props.onDragBeforeStart();
      }
    };
    _this.onDragStart = function (start, provided) {
      provided.announce(_this.messenger('@dm/components.simple-drop-zone.start-drag', {
        position: start.source.index + 1
      }));
      if (_this.props.onDragStart) {
        _this.props.onDragStart(start, provided);
      }
    };
    _this.onDragUpdate = function (update, provided) {
      if (!update.destination) {
        provided.announce(_this.messenger('@dm/components.simple-drop-zone.not-droppable'));
      } else if (update.source.droppableId !== update.destination.droppableId) {
        provided.announce(_this.messenger('@dm/components.simple-drop-zone.moved-list'), {
          source: update.source.droppableId,
          sourcePosition: update.source.index + 1,
          destination: update.destination.droppableId,
          destinationPosition: update.destination.index + 1
        });
      } else {
        provided.announce(_this.messenger('@dm/components.simple-drop-zone.moved-item', {
          position: update.destination.index + 1
        }));
      }
      if (_this.props.onDragUpdate) {
        _this.props.onDragUpdate(update, provided);
      }
    };
    _this.onDragEnd = function (result, provided) {
      if (_this.props.onDragEnd) {
        _this.props.onDragEnd(result, provided);
      }
      var source = result.source,
        destination = result.destination;
      var failure = SimpleDropZone.getFailConditions(result);
      if (failure) {
        provided.announce(_this.messenger(failure, {
          position: source.index + 1,
          destinationPosition: destination && destination.index + 1
        }));
        return;
      }
      var items = SimpleDropZone.reorder(_this.getItems(), source.index, destination.index);
      var updatedItems = _this.setItems(items);
      _this.props.onUpdateOrder(updatedItems);
      provided.announce(_this.messenger('@dm/components.simple-drop-zone.drop-new-position', {
        position: source.index + 1,
        destinationPosition: destination.index + 1
      }));
    };
    _this.setItems = function (updatedItems) {
      var _this$props = _this.props,
        getter = _this$props.getter,
        items = _this$props.items;
      if (getter) {
        return set(getter)(updatedItems)(items);
      } else {
        return updatedItems;
      }
    };
    _this.getItems = function () {
      var _this$props2 = _this.props,
        getter = _this$props2.getter,
        items = _this$props2.items;
      if (getter) {
        return getNested(getter)(items);
      } else {
        return items;
      }
    };
    _this.uuid = uuid();
    return _this;
  }
  _createClass(SimpleDropZone, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        children = _this$props3.children,
        idAttribute = _this$props3.idAttribute,
        isDropDisabled = _this$props3.isDropDisabled;
      return /*#__PURE__*/React.createElement(DragDropContext, {
        onDragBeforeStart: this.onDragBeforeStart,
        onDragStart: this.onDragStart,
        onDragUpdate: this.onDragUpdate,
        onDragEnd: this.onDragEnd
      }, /*#__PURE__*/React.createElement(Droppable, {
        droppableId: "droppable-".concat(this.uuid),
        type: "SIMPLE",
        isDropDisabled: isDropDisabled
      }, function (provided, snapshot) {
        return /*#__PURE__*/React.createElement("div", Object.assign({
          ref: provided.innerRef
        }, provided.droppableProps, {
          className: "_dropzone _dropzone--simple"
        }), children({
          items: _this2.getItems(),
          idAttribute: idAttribute
        }), provided.placeholder);
      }));
    }
  }]);
  return SimpleDropZone;
}(React.Component);
SimpleDropZone.reorder = function (list, startIndex, endIndex) {
  var result = Array.from(list);
  var _result$splice = result.splice(startIndex, 1),
    _result$splice2 = _slicedToArray(_result$splice, 1),
    removed = _result$splice2[0];
  result.splice(endIndex, 0, removed);
  return result;
};
SimpleDropZone.getFailConditions = function (result) {
  var source = result.source,
    destination = result.destination;
  if (result.reason === 'CANCEL') {
    return '@dm/components.simple-drop-zone.cancelled';
  }
  if (!destination) {
    return '@dm/components.simple-drop-zone.no-destination';
  }
  if (source.droppableId !== destination.droppableId) {
    return '@dm/components.simple-drop-zone.drop-new-list';
  }
  if (source.index === destination.index) {
    return '@dm/components.simple-drop-zone.drop-same-position';
  }
};
var messages = normalizeLocaleData(en, '@dm/components.simple-drop-zone');
var enhanced = compose(withAdditionalIntl(messages), injectIntl)(SimpleDropZone);
enhanced.displayName = 'Enhanced(SimpleDropZone)';
export default enhanced;